<template>
  <div>
    <Modal
    v-model="isShow"
    :loading="loading"
    :width="640"
    :mask-closable="false"
    @on-ok="ok"
    >
      <h3 slot="header" class="modal-header">新增元数据分配</h3>
      <Row>
        <Col span="8">
          <Select v-model="orgFid" placeholder="机构名称" filterable @on-change="getConFid">
            <Option value=''>请选择</Option>
            <Option v-for="item in companyList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </Col>
      </Row>
      <Row style="margin-top:20px">
      <Transfer
        :data="metaField"
        :target-keys="targetKeys1"
        :render-format="render1"
        :titles="['元数据列表','已分配列表']"
        :list-style="listStyle"
        filterable
        @on-change="handleChange1"></Transfer>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { unPermissionMetaField,saveMetaPermission } from 'api/metadistribution'
export default {
  name:'Add',
  props:{
    companyList:{
      type:Array,
      default(){
        return []
      }
    },
    n: {
      type: Number,
      default: 0
    },
  },
  watch:{
    n(){
      this.orgFid = ''
      this.targetKeys1 = []
      this.newMetaFieldKey = []
      this.metaField = []
      this.isShow = true
    },
    companyList(newVal,oldVal){
      this.companyList = newVal
    }
  },
  data(){
    return{
      targetKeys1: this.getTargetKeys(),
      loading: true,
      isShow:false,
      orgFid:'',
      newMetaFieldKey:[],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      metaField:[],
    }
  },
  created(){
    
  },
  methods:{
    getConFid(value){
      this.orgFid = value
      if(!value) return
      this.metaField = []
      this.getAllMetaField();
    },
    getAllMetaField(){
      unPermissionMetaField({
        orgFid:this.orgFid
      })
      .then( res => {
        res.data.map( (item,index) => {
          this.metaField.push(
            Object.assign({},item,{'key':index+1},{'label':item.fieldName})
          )
        })
      })
    },
    getTargetKeys () {
      return []
    },
    render1 (item) {
      return item.label;
    },
    handleChange1 (newTargetKeys, diraection, moveKeys) {
      this.targetKeys1 = newTargetKeys;
      this.newMetaFieldKey = []
      this.metaField.filter((item)=>{
        if(this.targetKeys1.indexOf(item.key) > -1){
          this.newMetaFieldKey.push(item.fieldKey);
        }
      })
    },
    ok(){
      if(!this.orgFid){
        this.$Message.info('请选择机构名称')
        this.changeLoading();
        return false
      }
      if(!this.newMetaFieldKey.length){
        this.$Message.info('请选择需要分配的元数据')
        this.changeLoading();
        return false
      }
      saveMetaPermission({
        fieldKey:this.newMetaFieldKey,
        orgFid:this.orgFid
      })
      .then( res => {
        this.newMetaFieldKey = []
        this.$emit('done')
        this.$Message.success('保存成功')
      }).catch(error=>{
        this.$Message.info('保存失败')
      }).finally(()=>{
        this.changeLoading();
        this.isShow = false
      })
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
  }
}
</script>

<style>

</style>